export const SegmentType = {
  TRIP_SEGMENT: 'TripSegment',
  EVENT_SEGMENT: 'EventSegment',
} as const;
